import React, { useState } from "react";
import { LuPhoneCall } from "react-icons/lu";
import { BsChatLeftText } from "react-icons/bs";
// import { CiLocationOn } from "react-icons/ci";
import { contact } from "../Constants/Constants";
import { useForm } from "react-hook-form";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../Configuration/Configuration";
import moment from "moment";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

export default function Contact() {
  const [isLoading, setIsLoading] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      data.time = moment().format("Do MMMM YYYY");
      console.log("Sending data to Firestore: ", data);
      await addDoc(collection(db, "data"), data);
      toast.success("Message submitted successfully!");
      reset();
    } catch (e) {
      toast.error("Something went wrong. Please try later!", e);
    } finally {
      setIsLoading(false);
    }
  };

  const formFields = [
    {
      name: "name",
      type: "text",
      placeholder: "Your Name*",
      message: "Please enter your name.",
    },
    {
      name: "email",
      type: "email",
      placeholder: "Your Email*",
      message: "Please enter your email.",
    },
    {
      name: "subject",
      type: "text",
      placeholder: "Subject*",
      message: "Please enter subject.",
    },
    {
      name: "phone",
      type: "tel",
      placeholder: "Phone*",
      message: "Please enter contact number.",
    },
  ];

  return (
    <div className="row">
      <motion.div
        className="col-lg-5 col-md-12"
        initial={{ opacity: 0, x: -75 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <div className="getInTouchDiv">
          <h6>Contact Me</h6>
          <h2>Turning Ideas Into Reality, Together</h2>
        </div>

        <div
          className="media d-flex gap-3 align-items-center"
          style={{ marginLeft: "-7px" }}
        >
          <LuPhoneCall className="mediaIcon" />
          <div className="mediaBody">
            <h6>Cell number</h6>
            <h4 style={{ fontSize: "24px" }}>{contact.number}</h4>
          </div>
        </div>

        <div className="media d-flex gap-3 align-items-center">
          <BsChatLeftText className="mediaIcon" />
          <div className="mediaBody">
            <h6>Contact Me</h6>
            <h4 style={{ fontSize: "24px" }}>{contact.email}</h4>
          </div>
        </div>

        {/*<div className="media d-flex gap-3 align-items-center">
          <CiLocationOn className="mediaIcon" />
          <div className="mediaBody">
            <h6>Location</h6>
            <h4 style={{ fontSize: "24px" }}>{contact.location}</h4>
          </div>
        </div>*/}
      </motion.div>

      <div className="col-lg-7 col-md-12 formDiv">
        <motion.div
          className="getInTouchDiv"
          initial={{ opacity: 0, x: 75 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <h6>Contact us</h6>
          <h2>Let me know here</h2>
        </motion.div>

        <motion.div
          className="inputDiv"
          initial={{ opacity: 0, x: 75 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {formFields.map((field) => (
                <div className="col-md-6 col-12" key={field.name}>
                  <input
                    type={field.type}
                    placeholder={field.placeholder}
                    className="form-control"
                    {...register(field.name, {
                      required: {
                        value: true,
                        message: field.message,
                      },
                    })}
                    onInput={(e) => {
                      if (field.name === "phone") {
                        e.target.value = e.target.value.replace(/\D/g, "");
                      }
                    }}
                  />

                  <p className="errorPara">{errors[field.name]?.message}</p>
                </div>
              ))}
            </div>

            <textarea
              rows="6"
              className="form-control textArea"
              placeholder="Write your message here..."
              {...register("message", {
                required: {
                  value: true,
                  message: "Please enter a message.",
                },
              })}
            ></textarea>
            <p className="errorPara">{errors.message?.message}</p>

            <div className="sendMsgDiv">
              <button className="sendMsgBtn" disabled={isLoading}>
                {isLoading ? (
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  "Send Message"
                )}
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
